import { NgModule } from '@angular/core';
import { CompanyAsyncExportComponent } from './company-async-export.component';
import { SiModalModule } from '../si-modal';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {  MatInputModule } from '@angular/material/input';
import {  MatButtonModule } from '@angular/material/button';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  DuplicateResolutionRadioGroupModule
} from '../ui-components/duplicate-resolution-group/duplicate-resolution-radio-group.module';

@NgModule({
    declarations: [CompanyAsyncExportComponent],
    exports: [
        CompanyAsyncExportComponent
    ],
    imports: [
        SiModalModule,
        ReactiveFormsModule,
        CommonModule,
        DuplicateResolutionRadioGroupModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule
    ]
})
export class CompanyAsyncExportModule {}
